/* ============================================================================
   VANGUARD PRODUCT SYSTEM — v-gallery.js
   ----------------------------------------------------------------------------
   Mejora progresiva de la galería del Hero. La galería FUNCIONA SIN ESTE
   ARCHIVO: el escenario es un contenedor de scroll nativo con scroll-snap y
   las miniaturas son anclas a cada diapositiva. Este script solo añade lo que
   el CSS no puede resolver:

     · flechas anterior / siguiente, que exigen conocer la diapositiva actual;
     · marcar la miniatura activa;
     · evitar que al pulsar una miniatura salte también la página, efecto
       secundario de navegar por ancla.

   NO se replica el antipatrón de CLAUDE.md §5: no hay `transform: translateX`
   ni cálculo de anchos al pintar. Se usa `scrollTo` sobre el scroll nativo, y
   el ancho se lee en el momento del clic, cuando el layout ya está resuelto.

   CLICS POR DELEGACIÓN (no por referencia directa al nodo)
   Las flechas y miniaturas ya NO reciben `addEventListener` cada una por su
   cuenta. Un solo listener en `document` revisa, en cada clic, qué elemento
   fue pulsado. Esto evita el bug donde el HTML de la sección se repinta
   (theme editor, apps, "sections.json") y los botones quedan con el aspecto
   correcto pero sin el listener que se les había atado antes: la delegación
   no depende de que el nodo original siga siendo el mismo objeto en memoria,
   solo de que el atributo `data-v-gallery` siga estando en el DOM actual.
   ============================================================================ */

(function () {
  'use strict';

  function galleryState(root) {
    var stage = root.querySelector('.v-product-hero__stage');
    if (!stage) return null;
    var slidesLength = stage.querySelectorAll('.v-product-hero__slide').length;
    if (slidesLength < 2) return null;
    return { stage: stage, slidesLength: slidesLength };
  }

  function currentIndex(stage) {
    var w = stage.clientWidth;
    return w ? Math.round(stage.scrollLeft / w) : 0;
  }

  function updateArrows(root, stage, slidesLength) {
    var idx = currentIndex(stage);
    var stagePrev = root.querySelector('[data-v-gallery="stage-prev"]');
    var stageNext = root.querySelector('[data-v-gallery="stage-next"]');
    if (stagePrev) stagePrev.disabled = idx <= 0;
    if (stageNext) stageNext.disabled = idx >= slidesLength - 1;

    var thumbs = root.querySelectorAll('.v-product-hero__thumb-link');
    thumbs.forEach(function (t, i) {
      if (i === idx) {
        t.setAttribute('aria-current', 'true');
      } else {
        t.removeAttribute('aria-current');
      }
    });
  }

  function goTo(root, stage, slidesLength, index) {
    var i = Math.max(0, Math.min(slidesLength - 1, index));
    stage.scrollTo({ left: i * stage.clientWidth, behavior: 'smooth' });
    var thumbs = root.querySelectorAll('.v-product-hero__thumb-link');
    if (thumbs[i] && thumbs[i].scrollIntoView) {
      thumbs[i].scrollIntoView({ block: 'nearest', inline: 'nearest' });
    }
  }

  // Flechas del rail de miniaturas (anclas) y del escenario (botones).
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-v-gallery]');
    if (!trigger) return;
    var root = trigger.closest('.v-product-hero');
    if (!root) return;
    var state = galleryState(root);
    if (!state) return;

    var action = trigger.getAttribute('data-v-gallery');
    if (action === 'prev' || action === 'stage-prev') {
      e.preventDefault();
      goTo(root, state.stage, state.slidesLength, currentIndex(state.stage) - 1);
    } else if (action === 'next' || action === 'stage-next') {
      e.preventDefault();
      goTo(root, state.stage, state.slidesLength, currentIndex(state.stage) + 1);
    }
  });

  // Miniaturas: sin JS son anclas y el navegador también desplaza la página;
  // interceptando el clic el movimiento queda dentro del escenario.
  document.addEventListener('click', function (e) {
    var link = e.target.closest('.v-product-hero__thumb-link');
    if (!link) return;
    var root = link.closest('.v-product-hero');
    if (!root) return;
    var state = galleryState(root);
    if (!state) return;

    var thumbs = Array.prototype.slice.call(
      root.querySelectorAll('.v-product-hero__thumb-link')
    );
    var index = thumbs.indexOf(link);
    if (index === -1) return;

    e.preventDefault();
    goTo(root, state.stage, state.slidesLength, index);
  });

  // El scroll no burbujea hasta `document`, así que la sincronización de
  // flechas/miniatura activa sí necesita un listener por instancia. Se marca
  // con una bandera en el propio nodo para no duplicarlo si la sección se
  // reinicializa (theme editor / apps).
  function bindScrollSync(root) {
    var state = galleryState(root);
    if (!state) return;
    if (state.stage.dataset.vGalleryBound === 'true') {
      updateArrows(root, state.stage, state.slidesLength);
      return;
    }
    state.stage.dataset.vGalleryBound = 'true';

    var timer;
    state.stage.addEventListener(
      'scroll',
      function () {
        clearTimeout(timer);
        timer = setTimeout(function () {
          updateArrows(root, state.stage, state.slidesLength);
        }, 60);
      },
      { passive: true }
    );

    updateArrows(root, state.stage, state.slidesLength);
  }

  function initAll() {
    document.querySelectorAll('.v-product-hero').forEach(bindScrollSync);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // El editor de tema (y algunas apps) recargan secciones sin recargar la
  // página. Los clics ya no necesitan reinicializarse (son delegados), pero
  // el listener de scroll sí es por instancia.
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('.v-product-hero');
    if (root) bindScrollSync(root);
  });
})();
